import { cn } from "@/lib/utils";

type IconProps = { className?: string };

export function FacebookIcon({ className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      className={cn("shrink-0", className)}
    >
      <path d="M14 13.5h2.5l.5-3H14V8.5c0-.8.2-1.3 1.4-1.3H17V4.1C16.7 4.1 15.6 4 14.3 4 11.7 4 10 5.6 10 8.3V10.5H7.5v3H10V20h4z" />
    </svg>
  );
}

export function InstagramIcon({ className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      className={cn("shrink-0", className)}
    >
      <path d="M12 7.2A4.8 4.8 0 1 0 12 16.8 4.8 4.8 0 0 0 12 7.2zm0 7.9a3.1 3.1 0 1 1 0-6.2 3.1 3.1 0 0 1 0 6.2zm6.1-8.1a1.12 1.12 0 1 1-2.24 0 1.12 1.12 0 0 1 2.24 0zM12 2.2c-2.7 0-3.04.01-4.1.06-2.74.13-4.01 1.4-4.14 4.14-.05 1.06-.06 1.4-.06 4.1s.01 3.04.06 4.1c.13 2.74 1.4 4.01 4.14 4.14 1.06.05 1.4.06 4.1.06s3.04-.01 4.1-.06c2.74-.13 4.01-1.4 4.14-4.14.05-1.06.06-1.4.06-4.1s-.01-3.04-.06-4.1C20.11 3.66 18.84 2.39 16.1 2.26c-1.06-.05-1.4-.06-4.1-.06zm0 1.7c2.65 0 2.96.01 4.01.06 1.91.09 2.79.97 2.88 2.88.05 1.05.06 1.36.06 4.01s-.01 2.96-.06 4.01c-.09 1.91-.97 2.79-2.88 2.88-1.05.05-1.36.06-4.01.06s-2.96-.01-4.01-.06c-1.91-.09-2.79-.97-2.88-2.88-.05-1.05-.06-1.36-.06-4.01s.01-2.96.06-4.01c.09-1.91.97-2.79 2.88-2.88 1.05-.05 1.36-.06 4.01-.06z" />
    </svg>
  );
}

export function YoutubeIcon({ className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      className={cn("shrink-0", className)}
    >
      <path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 0 0 .5 6.2 31.6 31.6 0 0 0 0 12a31.6 31.6 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 0 0 2.1-2.1A31.6 31.6 0 0 0 24 12a31.6 31.6 0 0 0-.5-5.8zM9.75 15.5v-7l6.5 3.5-6.5 3.5z" />
    </svg>
  );
}

export function LinkedinIcon({ className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      className={cn("shrink-0", className)}
    >
      <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zM7.12 20.45H3.56V9h3.56v11.45zM22.23 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.46c.98 0 1.77-.77 1.77-1.73V1.73C24 .77 23.21 0 22.23 0z" />
    </svg>
  );
}
